import ClipboardJS from 'clipboard/dist/clipboard.min';
import $ from "../jquery_global";

window.TraceTemplate = {
  init() {
    let self = this
    var clipboard =new ClipboardJS('.clipboard-btn');
    clipboard.on('success', function(e) {
      self.setTooltip(e.trigger, 'Copied!');
      self.hideTooltip(e.trigger);
    });
  },

  setTooltip(btn, message) {
    $(btn).tooltip('hide')
      .attr('data-original-title', message)
      .tooltip('show');
  },

  hideTooltip(btn) {
    setTimeout(function() {
      $(btn).tooltip( "dispose" )
    }, 1000);
  },

  handleArchiveBatchOnClick() {
    $(document).on('click', '.toggle-archive-batch', (event) => {
      this.handleArchiveBatch(event);
    })
  },

  handleArchiveBatch(e) {
    const isArchived = JSON.parse(e.target.value)
    let params = {
      batch: {
        is_archived: !isArchived
      }
    }

    $.ajax({
      url: `/admin/batches/${e.target.dataset.batchUuid}/mark_archived`,
      type: 'PATCH',
      data: params,
      dataType: "json",
      success: (data) => {
        if (data) {
          if (data.error) {
            e.target.checked = isArchived
            e.target.value = isArchived
            alert(data.error)
          }
          e.target.checked = !isArchived
          e.target.value = !isArchived
          let successMessage = isArchived ? "Trace was unarchived." : "Trace was archived."
          alert(successMessage)
        }
      },
      failure: (error) => {
        alert(error)
      }
    });
  },

  handleHeroImage() {
    $(document).off('click', '.delete-hero-image-btn').on('click', '.delete-hero-image-btn', (event) => {
      const $img = $(event.currentTarget).siblings('img')

      $.ajax({
        url: `/admin/trace_templates/${$img.data('batchId')}/hero_image`,
        type: 'DELETE',
        data: {
          hero_image_id: $img.data('attachmentId')
        },
        dataType: "json",
        success: (data) => {
          $img.parents('.col-auto').remove()
        },
        failure: (error) => {
          alert(error)
        }
      })
    })

    $(document).off('click', 'button.upload-hero-image-btn').on('click', 'button.upload-hero-image-btn', function(e) {
      e.preventDefault();
      const btn = $(e.currentTarget)
      btn.prop("disabled", true);

      const data = new FormData()
      for (const file of document.querySelector('#heroImageUpload').files) {
        console.log(file)
        data.append('hero_images[]', file)
      }
      $.post({
        url: btn.data('url'),
        type: 'POST',
        data,
        dataType: 'script',
        processData: false,
        contentType: false,
      }).done((_res) => {
        $('label[for="#heroImageUpload"]').text("Hero images");
      })
    })
  },

  handleCreateContentBlock() {
    $('form#new_content_block_template').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const form = $(this)
      const formData = new FormData(this);

      $.ajax({
        url: form.attr('action'),
        type: 'POST',
        data: formData,
        dataType: 'script',
        processData: false,
        contentType: false,
      })
    })
    $(document).on('click', 'form#new_content_block_template .delete-btn', function(e) {
      e.preventDefault();

      const button = $(this)
      $.ajax({
        url: button.data('url'),
        type: 'DELETE',
        dataType: 'script',
      })
    })
  },

  handleCreateCustomContentBlock() {
    $('form#new_custom_content_block_template').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const form = $(this)
      const formData = new FormData(this);

      $.ajax({
        url: form.attr('action'),
        type: 'POST',
        data: formData,
        dataType: 'script',
        processData: false,
        contentType: false,
      })
    })
    $(document).on('click', 'form#new_custom_content_block_template .delete-btn', function(e) {
      e.preventDefault();

      const button = $(this)
      $.ajax({
        url: button.data('url'),
        type: 'DELETE',
        dataType: 'script',
      })
    })
  }
};
